import {
  EducationMaterialControllerApi,
  UploadEducationMaterialDocumentFormatEnum,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type EducationMaterialCreateParam = {
  providerId: string;
  name: string;
  description: string;
  fileName: string;
  condition: string;
  documentFormat: UploadEducationMaterialDocumentFormatEnum;
  file: File;
  specialityId?: string;
  documentDate?: string;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const useEducationMaterialCreate = () =>
  useMutationWithLoading(async (params: EducationMaterialCreateParam) =>
    new EducationMaterialControllerApi(
      getConfigObject()
    ).uploadEducationMaterial(
      params.providerId,
      params.name,
      params.description,
      params.fileName,
      params.condition,
      params.documentFormat,
      params.file,
      params.specialityId ?? undefined,
      params.documentDate,
      params.xTENANTID
    )
  );
